import { FindIngestionsQueryParams, useFindIngestions } from "~/gen/api"

export const useFindIngestionsQuery = (params: FindIngestionsQueryParams) =>
  useFindIngestions(params, {
    query: {
      refetchInterval: 10000, // 10 seconds
    },
  })
